module.exports = __webpack_public_path__ + "img/login2.3b6ef8ff.jpg";